import type { ImageSourcePropType } from 'react-native';
import { theme } from '../theme';

export interface OnboardingItem {
  id: string;
  title: string;
  description: string;
  image?: ImageSourcePropType;
  video?: string;
  backgroundColor: string;
}

export const ONBOARDING_SLIDES: OnboardingItem[] = [
  {
    id: '1',
    title: 'Ready to Start?',
    description:
      'Join thousands of businesses already using BizPlus POS to boost profits.',
    image: require('../assets/onboarding/slide1.webp'),
    backgroundColor: theme.colors.primaryDark,
  },
  {
    id: '2',
    title: 'Sales Made Simple',
    description:
      'Select items and quantity, select payment method, print and share receipts for fast checkouts.',
    image: require('../assets/onboarding/slide2.webp'),
    backgroundColor: theme.colors.success,
  },
  {
    id: '3',
    title: 'Sales and Cashflow Management',
    description:
      'Be on top of your cashflow distribution and volume for maximum business performance.',
    image: require('../assets/onboarding/slide3.webp'),
    backgroundColor: theme.colors.premiumDark,
  },
  {
    id: '4',
    title: 'Smart Inventory Management',
    description:
      'Track inventory and manage stock levels with real-time alerts when items run low. Never miss a sale again.',
    image: require('../assets/onboarding/slide4.webp'),
    backgroundColor: theme.colors.primary,
  },
];

// Welcome screen: marquee wall images
export const WELCOME_WALL_IMAGES: string[] = [
  'https://res.cloudinary.com/dbi34vmol/image/upload/f_webp,q_auto/v1771782622/bizplus/welcome/wmremove-transformed_1_nljtad.jpg',
  'https://res.cloudinary.com/dbi34vmol/image/upload/f_webp,q_auto/v1771783383/bizplus/welcome/result_0_qvbcpr.png',
  'https://res.cloudinary.com/dbi34vmol/image/upload/f_webp,q_auto/v1771782622/bizplus/welcome/istockphoto-2220085621-1024x1024_nifpvw.jpg',
  'https://res.cloudinary.com/dbi34vmol/image/upload/f_webp,q_auto/v1771782621/bizplus/welcome/wmremove-transformed_sltvhg.jpg',
  'https://res.cloudinary.com/dbi34vmol/image/upload/f_webp,q_auto/v1771782621/bizplus/welcome/istockphoto-2232441345-1024x1024_c1pps3.jpg',
  'https://res.cloudinary.com/dbi34vmol/image/upload/f_webp,q_auto/v1771782620/bizplus/welcome/istockphoto-1157463906-1024x1024_md7cr6.jpg',
].filter(Boolean) as string[];
